module.exports = __webpack_public_path__ + "img/account.6d2c7837.svg";